/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Total_EventInputs */



/**
* | output |
* | --- |
* | "Total Event" |
*
* @param {Total_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const total_event = /** @type {((inputs?: Total_EventInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Total_EventInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Total d’événements")
	if (locale === "de") return /** @type {LocalizedString} */ ("Gesamtereignis")
	if (locale === "it") return /** @type {LocalizedString} */ ("Evento totale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Всего событий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Evento total")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("总事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("合計イベント")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कुल घटना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Evento Total")
	return /** @type {LocalizedString} */ ("Total Event")
});